import { FEATURES } from '/src/features/_global/constants';

export const INSTALLATION_PERMISSIONS = {
  [FEATURES.INSTALLATION]: ({ capabilities }) => ({
    navigate: capabilities?.installation.permissions.nav,
    view: capabilities?.installation.permissions.view,
  }),
};
